import React, {useState} from "react"
import styled from "styled-components/macro"
import {
  ExpandedBox,
  ExpandedBoxBackground,
  Title,
  Description,
  SubDescription,
  ImageBox,
  ImageContainer,
  FloatContainer,
  StatsBox,
  Stats,
  StatName,
  Value,
  Glyph,
  CloseButton,
  TooltipBox
} from "./styled/styles"
import banners from "../constants/banners"

export default props => {
  const stats = props.data.stats[0]
  const [tooltipState, setTooltipState] = useState(false)
  const [currentBanner, setCurrentBanner] = useState(false)

  const banner = banners.find(
    p => p.name === props.data.banner
  );

console.log(currentBanner)
  return (
    <ExpandedBoxBackground>
      <ExpandedBox theme={props.theme}>
        <CloseButton onClick={() =>
          props.setExpanded(false)
        }>X</CloseButton>
        {props.type === "Weapons" || props.type === "Primals" ?
          <ImageContainer>
            <Glyph
              src={require("../images/Weapons/Glyph.png")}
            />
            <FloatContainer>
              <img
                src={require(`../images/${props.type}/${props.data.name
                  .toLowerCase()
                  .split(" ")
                  .join("")
                  .replace("!", "")}.png`)}
                alt={props.data.name}
                css={`
              width: auto;
              height: ${props.primal ? "275px" : "100px"};
              margin: 0;
            `}
              />
            </FloatContainer>
          </ImageContainer>
          : (
            <FloatContainer css={`position: relative;`}>
              <img
                src={require(`../images/${props.type}/${props.data.name
                  .toLowerCase()
                  .split(" ")
                  .join("")
                  .replace("!", "")}.png`)}
                alt={props.data.name}
                css={`
              width: auto;
              height: ${props.primal ? "275px" : "100px"};
              margin: 0;
            `}
              />
            </FloatContainer>
          )
        }
        <Title theme={props.theme}>{props.data.name} </Title>
        <Description theme={props.theme}>{props.data.description}</Description>
        {props.data.quote ?
          <SubDescription
            theme={props.theme}
          >
            {props.data.quote}
          </SubDescription> : null}
        {props.data.banner ? (
          <div css={`
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          `}
                onMouseEnter={() => {
                  setTooltipState(true);
                  setCurrentBanner(banner);
                }}
              onMouseLeave={() => {
                setTooltipState(false);
              }}>
            <ImageBox css={`
          margin-top: 16px; 
          border: 2px solid #ffffffab;
          padding: 8px;
          border-radius: 16px;
  &:hover{
    background: #ffffff;
  }`}
          >
              <img
                src={require(`../images/Banners/${props.data.banner
                  .toLowerCase()
                  .split(" ")
                  .join("")
                  .replace("!", "")}.png`)}
                alt={props.data.name}
                style={{
                  width: "auto",
                  height: "55px",
                  margin: 0,
                }}
            />
            </ImageBox>
            {tooltipState && (
              <TooltipBox>
                <Description theme={props.theme} css={`color:white; font-weight: bold; opacity:1;`}>{banner.description}</Description>
                {banner.stats.map((stat, index) => (
                  <SubDescription theme={props.theme} key={index} css={`color:white; font-weight: bold; opacity:1;`}>
                    {index + 1}. {stat}
                  </SubDescription>
                ))}
              </TooltipBox>
            )}
          </div>
          ) : null}

        <StatsBox theme={props.theme}>

          {typeof stats === "string" ? (
            <div>
              {props.type === "Banners" ? (
                <SubDescription theme={props.theme}>
                  Equipping up to 4 items with the same banner grants increasingly powerful set bonuses.
                </SubDescription>
              ) : null}
              {props.data.stats.map((stat, index) => (
                <SubDescription theme={props.theme} key={index}>
                  {index + 1}. {stat}
                </SubDescription>
              ))}
            </div>
          ) : stats && typeof stats.name === "string" ? (
            props.data.stats.map((stat, index) => (
              <Stats theme={props.theme} key={index}>
                <StatName theme={props.theme}>{stat.name}</StatName>
                <Value theme={props.theme}>{stat.value}</Value>
              </Stats>
            ))
          ) : (
            stats.stats &&
            stats.stats.map((stat, index) => (
              <Stats theme={props.theme} key={index}>
                <StatName theme={props.theme}>{stat.name}</StatName>
                <Value theme={props.theme}>{stat.value}</Value>
              </Stats>
            ))
          )}
        </StatsBox>
      </ExpandedBox>
    </ExpandedBoxBackground>
  )
}
